import script from "./ProductTableLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductTableLink.vue?vue&type=script&lang=ts&setup=true"

import "./ProductTableLink.vue?vue&type=style&index=0&id=9a89fae0&lang=scss"

const __exports__ = script;

export default __exports__